<template>
<div class="fc-view-container">
    <table id="evenements">
        <thead>
        <th>
            <tr>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </th>
        </thead>
        <tbody>
        <template v-for="evt in metaEvenements">
            <tr v-if="evt.type === 'ANNEE'" class="ANNEE"><td colspan="3">{{evt.valeur}}</td></tr>
            <tr v-else-if="evt.type === 'MOIS_JOUR'" class="MOIS_JOUR">
                <td class="NOM_JOUR">{{evt.valeur}}</td>
                <td class="EVT_JOUR">
                    <template v-if="evt.longEvts">
                        <a v-for="evt3 in evt.longEvts" :href="getUrl(evt3.url)" :class="evt3.className" target="_blank">
                            {{evt3.title}}
                        </a>
                    </template>
                  <template v-if="evt.evts">
                    <a v-for="evt2 in evt.evts" :href="getUrl(evt2.url)" :class="evt2.className" target="_blank">
                        {{evt2.moment}}&nbsp;: {{evt2.title}}
                    </a>
                  </template>
                </td>
            </tr>
            <tr v-else-if="evt.type === 'PERIODE'" class="MOIS_JOUR">
                <td class="NOM_JOUR">{{evt.valeur}}</td>
                <td class="EVT_JOUR">
                    <template v-if="evt.longEvts">
                        <a v-for="evt3 in evt.longEvts" :href="getUrl(evt3.url)" :class="evt3.className" target="_blank">
                            {{evt3.title}}
                        </a>
                    </template>
                </td>
            </tr>
        </template>
    </tbody>
    </table>
</div>
</template>

<script>
    import {mixin} from "./Senateur.mixin";
    import { mapActions } from "vuex";
    import {
      ACCEDE_EVTS,
      ACCEDE_SEN_PAR_MATRICULE,
      CHARGE_EVTS_PAR_MATRICULE,
      CHARGE_SENS_DISPOS
    } from "../store/types";
    import isEqual from "lodash/isEqual";
    import moment from "moment";

    export default {
      mixins: [mixin],
      data() {
        return {
          jour: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
          mois: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
        };
      },
      methods: {
        ...mapActions({
          chargeEvenements: CHARGE_EVTS_PAR_MATRICULE,
          chargeSens: CHARGE_SENS_DISPOS
        }),
        getUrl(param) {
          if(!param) {
            return undefined;
          }
          if(param.startsWith("http")) {
            return param;
          }
          return `https://www.senat.fr${param}`;
        },
        computeNextDay(jour) {
          if(undefined === jour) {
            return undefined;
          }
          let lendemain = new Date(jour.getTime() + 24 * 60 * 60 * 1000);
          if(23 === lendemain.getHours()) {
            // passage à l'heure d'hiver
            lendemain.setTime(lendemain.getTime() + 60 * 60 * 1000);
          } else if(1 === lendemain.getHours()) {
            lendemain.setHours(0);
          }
          return lendemain;
        },
        computePrevDay(jour) {
          if(undefined === jour) {
            return undefined;
          }
          let veille = new Date(jour.getTime() - 24 * 60 * 60 * 1000);
          if(23 === veille.getHours()) {
            // passage à l'heure d'hiver
            veille.setTime(veille.getTime() - 60 * 60 * 1000);
          } else if(1 === veille.getHours()) {
            veille.setHours(0);
          }
          return veille;
        }
      },
      watch: {
        matricule: (matricule) => {
          this.chargeEvenements(matricule);
        }
      },
      computed: {
        // même chose que les évènements, mais avec des meta-données distinctes en plus
        metaEvenements() {
          let evts = this.$store.getters[ACCEDE_EVTS](this.matricule);
          let curSen = this.$store.getters[ACCEDE_SEN_PAR_MATRICULE](this.matricule);
          if((undefined === evts) || (0 === evts.length)) {
            return [];
          }
          let premierNovembre = moment("2015-11-01").toDate();
          // parano : un Sénateur a forcément des mandats
          if((undefined !== curSen.mandats) && 0 < curSen.mandats.length) {
            curSen.mandats.forEach(m => {
              m.dateDebut = moment(m.debut).toDate();
              if(m.fin) {
                m.dateFin = moment(m.fin).toDate();
              } else {
                m.dateFin = undefined;
              }
            });
            let debMandat = curSen.mandats[0].dateDebut;
            if(debMandat && debMandat > premierNovembre) {
              evts.push({
                title: "Début de mandat",
                startDate: debMandat,
                endDate: this.computeNextDay(debMandat),
                className: "MANDAT",
                libelle: null,
                allDay: true
              });
            }
            let finMandat = curSen.mandats[0].dateFin;
            for(let i = 1;
                i < curSen.mandats.length;
                i++) {
              let curDebMandat = curSen.mandats[i].dateDebut;
              let lendemainFinMandat = this.computeNextDay(finMandat);
              if(lendemainFinMandat.getTime() !== curDebMandat.getTime()) {
                if(finMandat && finMandat > premierNovembre) {
                  evts.push({
                    title: "Fin de mandat",
                    startDate: finMandat,
                    endDate: this.computeNextDay(finMandat),
                    className: "MANDAT",
                    libelle: null,
                    allDay: true
                  });
                }
                if(curDebMandat && curDebMandat > premierNovembre) {
                  evts.push({
                    title: "Début de mandat",
                    startDate: curDebMandat,
                    endDate: this.computeNextDay(curDebMandat),
                    className: "MANDAT",
                    libelle: null,
                    allDay: true
                  });
                }
                debMandat = curDebMandat;
              }
              finMandat = curSen.mandats[i].dateFin;
            }
            if(finMandat && finMandat > premierNovembre) {
              evts.push({
                title: "Fin de mandat",
                startDate: finMandat,
                endDate: this.computeNextDay(finMandat),
                className: "MANDAT",
                libelle: null,
                allDay: true
              });
            }
          }
          evts.forEach(e => {
            if(undefined === e.startDate) {
              e.startDate = moment(e.start).toDate();
            }
            if(undefined === e.endDate) {
              e.endDate = moment(e.end).toDate();
            }
          });
          evts.sort((e1,e2) => e2.startDate - e1.startDate);
          let longEvts = evts.filter(e => (true === e.allDay) || ((e.endDate - e.startDate) > 24 * 60 * 60 * 1000));
          evts = evts.filter(e => !longEvts.includes(e));
          if(undefined === evts) {
            return [];
          }
          longEvts = longEvts.map(le => {
            let mandatDebut = findMandat(le.startDate, curSen.mandats);
            let mandatFin = findMandat(this.computePrevDay(le.endDate), curSen.mandats);
            if(!mandatDebut && !mandatFin) {
              // dans aucun mandat.
              // on marque pour suppression
              le.startDate = le.endDate = undefined;
            } else if(mandatDebut === mandatFin) {
              // inclus entièrement dans un mandat. Rien à faire.
            } else if(mandatDebut && !mandatFin) {
              le.endDate = this.computeNextDay(mandatDebut.dateFin);
            } else if(!mandatDebut && mandatFin) {
              le.startDate = mandatFin.dateDebut;
            }
            // si l'évènement est à cheval sur deux mandats, on le laisse
            // et on revoie le
            return le;
          }).filter(le => (undefined !== le.startDate) && (undefined !== le.endDate));
          let previousStart;
          if(0 < evts.length) {
            previousStart = evts[0].startDate;
          } else {
            previousStart = longEvts[0].startDate;
          }
          let curJour = previousStart.getDate();
          // attention, mois de 0 à 11
          let curMois = previousStart.getMonth();
          let curAnnee = previousStart.getFullYear();
          let metaEvenements = [];
          let curStructJour;

          evts.forEach(e => {
            let debut = e.startDate;
            let fin = e.endDate;
            let issueDay = false;
            if((undefined === curMois) || (curMois !== debut.getMonth())) {
              curMois = debut.getMonth();
              issueDay = true;
              curJour = undefined;
            }
            if((undefined === curJour) || (curJour !== debut.getDate())) {
              curJour = debut.getDate();
              issueDay = true;
            }
            if(issueDay || (undefined === curStructJour)) {
              if((undefined !== curStructJour) && !isEqual(metaEvenements[metaEvenements.length - 1], curStructJour)) {
                metaEvenements.push(curStructJour);
              }
              let valeurNumerique = moment(debut).toDate();
              valeurNumerique.setHours(0);
              valeurNumerique.setMinutes(0);
              valeurNumerique.setMilliseconds(0);
              if((undefined === curStructJour) || (curStructJour.valeurNumerique.getTime() !== valeurNumerique.getTime())) {
                curStructJour = {
                  type: "MOIS_JOUR",
                  valeur: `${this.jour[debut.getDay()]} ${debut.getDate()} ${this.mois[debut.getMonth()]}`,
                  valeurNumerique,
                  evts: []
                };
              }
            }
            let me = Object.assign({}, { title: e.title, url: e.url, className: e.className });
            me.moment = timeToStringHHmm(debut) + " - " + timeToStringHHmm(fin);

            curStructJour.evts.push(me);
            if((undefined === curAnnee) || (curAnnee !== debut.getFullYear())) {
              curAnnee = previousStart.getFullYear();
              do {
                metaEvenements.push({type: "ANNEE", valeur: curAnnee});
                curAnnee--;
              } while(curAnnee !== debut.getFullYear());
              curMois = undefined;
              curJour = undefined;
            }
            previousStart = debut;
          });

          curAnnee = previousStart.getFullYear();
          let borne;
          for(let i = 0; i < curSen.mandats.length; i++) {
            let m = curSen.mandats[i];
            if((2015 >= m.dateDebut.getFullYear()) && (undefined === m.dateFin || (2015 <= m.dateFin.getFullYear()))) {
              borne = 2014;
              break;
            }
            if(2015 <= m.dateDebut.getFullYear()) {
              borne = m.dateDebut.getFullYear() - 1;
              break;
            }
          }
          do {
            metaEvenements.push({type: "ANNEE", valeur: curAnnee});
            curAnnee--;
          } while(borne !== curAnnee);
          longEvts.forEach(e => {
            e.valeurNumerique = e.endDate;
            e.valeurNumerique.setHours(0);
            e.valeurNumerique.setMinutes(0);
            e.valeurNumerique.setSeconds(0);
            e.valeurNumerique.setMilliseconds(0);
            e.valeurNumeriqueDeb = e.startDate;
            e.valeurNumeriqueDeb.setHours(0);
            e.valeurNumeriqueDeb.setMinutes(0);
            e.valeurNumeriqueDeb.setSeconds(0);
            e.valeurNumeriqueDeb.setMilliseconds(0);
          });
          longEvts.forEach(le => {
            let loopStart = new Date(le.valeurNumeriqueDeb.getTime());
            loopStart.setHours(0);
            loopStart.setMinutes(0);
            loopStart.setSeconds(0);
            for(var curDayNumeric = loopStart;
                curDayNumeric < le.valeurNumerique;
                curDayNumeric = new Date(curDayNumeric.getTime() + 24 * 60 * 60 * 1000)
            ) {
              if(23 === curDayNumeric.getHours()) {
                // passage à l'heure d'hiver
                curDayNumeric.setTime(curDayNumeric.getTime() + 60 * 60 * 1000);
              } else if(1 === curDayNumeric.getHours()) {
                curDayNumeric.setHours(0);
              }
              let mePrecIndexDeb = metaEvenements.findIndex(me => {
                return ("MOIS_JOUR" === me.type && me.valeurNumerique <= curDayNumeric) || ("ANNEE" === me.type && me.valeur === curDayNumeric.getFullYear());
              });

              let longJourDeb;
              if(-1 === mePrecIndexDeb) {
                longJourDeb = {
                  type: "MOIS_JOUR",
                  valeur: `${this.jour[curDayNumeric.getDay()]} ${curDayNumeric.getDate()} ${this.mois[curDayNumeric.getMonth()]}`,
                  valeurNumerique: curDayNumeric,
                  evts: []
                };
                metaEvenements.push(longJourDeb);
                mePrecIndexDeb = metaEvenements.length - 1;
              } else {
                let mePrecDeb = metaEvenements[mePrecIndexDeb];
                if("MOIS_JOUR" !== mePrecDeb.type || mePrecDeb.valeurNumerique.getTime() !== curDayNumeric.getTime()) {
                  longJourDeb = {
                    type: "MOIS_JOUR",
                    valeur: `${this.jour[curDayNumeric.getDay()]} ${curDayNumeric.getDate()} ${this.mois[curDayNumeric.getMonth()]}`,
                    valeurNumerique: curDayNumeric,
                    evts: []
                  };
                  if("MOIS_JOUR" !== mePrecDeb.type) {
                    metaEvenements.splice(mePrecIndexDeb, 0, longJourDeb);
                  } else {
                    metaEvenements.splice(mePrecIndexDeb, 0, longJourDeb);
                  }
                } else {
                  longJourDeb = mePrecDeb;
                }
              }
              if(!("longEvts" in longJourDeb)) {
                longJourDeb.longEvts = [];
              }
              longJourDeb.longEvts.push(le);
            }
          });

          let precIdx;
          let mePrec;
          let meCur;
          let metaEvenementsReduits = [];
          for(var curME = metaEvenements.length - 1;
              0 <= curME;
              curME--) {
            meCur = metaEvenements[curME];
            if(undefined === precIdx) {
              if("MOIS_JOUR" !== meCur.type) {
                metaEvenementsReduits.push(meCur);
                continue;
              }
              precIdx = curME;
              mePrec = meCur;
              if(0 !== curME) {
                continue;
              }
            }
            if(0 !== curME) {
              if((mePrec.longEvts || meCur.longEvts) && isEqual(mePrec.longEvts, meCur.longEvts) && (!mePrec.evts || 0 === mePrec.evts.length) && (!meCur.evts || 0 === meCur.evts.length)) {
                continue;
              } else {
                if(precIdx === (curME + 1)) {
                  metaEvenementsReduits.push(mePrec);
                } else {
                  let meEnd = metaEvenements[curME + 1];
                  metaEvenementsReduits.push({
                    type: "PERIODE",
                    valeur: `Du ${this.jour[mePrec.valeurNumerique.getDay()]} ${mePrec.valeurNumerique.getDate()} ${this.mois[mePrec.valeurNumerique.getMonth()]} au ${this.jour[meEnd.valeurNumerique.getDay()]} ${meEnd.valeurNumerique.getDate()} ${this.mois[meEnd.valeurNumerique.getMonth()]}`,
                    longEvts: mePrec.longEvts
                  });
                }
                if("MOIS_JOUR" !== meCur.type) {
                  metaEvenementsReduits.push(meCur);
                  precIdx = undefined;
                  mePrec = undefined;
                } else {
                  precIdx = curME;
                  mePrec = meCur;
                }
              }
            } else {
              if((mePrec.longEvts || meCur.longEvts) && isEqual(mePrec.longEvts, meCur.longEvts) && (!mePrec.evts || 0 === mePrec.evts.length) && (!meCur.evts || 0 === meCur.evts.length)) {
                metaEvenementsReduits.push({
                  type: "PERIODE",
                  valeur: `Du ${this.jour[mePrec.valeurNumerique.getDay()]} ${mePrec.valeurNumerique.getDate()} ${this.mois[mePrec.valeurNumerique.getMonth()]} au ${this.jour[meCur.valeurNumerique.getDay()]} ${meCur.valeurNumerique.getDate()} ${this.mois[meCur.valeurNumerique.getMonth()]}`,
                  longEvts: mePrec.longEvts
                });
              } else if(precIdx === (curME + 1)) {
                metaEvenementsReduits.push(mePrec);
                metaEvenementsReduits.push(meCur);
              } else {
                let meEnd = metaEvenements[curME + 1];
                metaEvenementsReduits.push({
                  type: "PERIODE",
                  valeur: `Du ${this.jour[mePrec.valeurNumerique.getDay()]} ${mePrec.valeurNumerique.getDate()} ${this.mois[mePrec.valeurNumerique.getMonth()]} au ${this.jour[meEnd.valeurNumerique.getDay()]} ${meEnd.valeurNumerique.getDate()} ${this.mois[meEnd.valeurNumerique.getMonth()]}`,
                  longEvts: mePrec.longEvts
                });
                metaEvenementsReduits.push(meCur);
              }
            }
          }
          // dernière étape : réduire les évènements conséctutifs
          return metaEvenementsReduits.reverse();
          // return metaEvenements;
        }
      },
      async created() {
        await this.chargeSens();
        this.chargeEvenements(this.matricule);
      }
    };

    function findMandat(date, mandats) {
      if(!mandats) {
        return undefined;
      }
      for(let i = 0; i < mandats.length; i++) {
        let m = mandats[i];
        if((!m.dateDebut || m.dateDebut <= date)
          && (!m.dateFin || m.dateFin >= date)) {
          return m;
        }
      }
      return undefined;
    }

    function timeToStringHHmm(date) {
      if(undefined === date) {
        return null;
      }
      let ret;
      if(10 > date.getHours()) {
        ret = "0";
      } else {
        ret = "";
      }
      ret = ret.concat(date.getHours());
      ret = ret.concat(":");
      if(10 > date.getMinutes()) {
        ret = ret.concat("0");
      }
      ret = ret.concat(date.getMinutes());
      return ret;
    }
</script>

<style scoped>

.ANNEE {
    background-color: black;
    color: white;
    text-align: center;
    vertical-align:middle;
    font-size: x-large;
    padding-left: 2vh;
    padding-right: 2vh;
}

.MOIS_JOUR {
    text-align: left;
}

.NOM_JOUR {
    text-align:center;
    border: lightgrey solid 1px;
    background-color: darkgrey;
    color: white;
}

.EVT_LONG {
    width: 10vw;
}

.EVT_JOUR {
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    justify-items: stretch;
    align-items: stretch;
}

.EVT_JOUR a {
    /*padding: 3px 5px;*/
    padding-top: 0.5vh;
    padding-bottom: 0.5vh;
    padding-left: 0.5vw;
    padding-right: 0.5vw;
    font-family: 'PT Sans', sans-serif;
    display: table-cell;
    flex-grow: 1;
    vertical-align: middle;
}

.EVT_LONG {
    display: inline-flex;
    flex-direction: row;
    justify-items: stretch;
    align-items: stretch;
}


table#evenements {
    width: 100%;
}

tr.MOIS_JOUR, tr.MOIS_JOUR td {
    min-height: 5vh;
}


a.COM_ENQUETE {
    background-color: #853100 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.COM_EURO {
    background-color: #ad4100 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.COM_SPECIALE {
    background-color: #d5550a !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.INSTANCE_INTERNATIONALE {
    background-color: #f37830 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.MISSION {
    background-color: #ff995d !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.AUTRE_TEMPORAIRE {
    background-color: #FFAF80 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.SEANCE_PLENIERE {
    background-color: #cd0020 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.COM_PERMANENTE {
    background-color: #a13646 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.CMP {
    background-color: #B54D5D !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.COM_PERMANENTE.AUDRAP {
    background-color: #c96474 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.COM_PERMANENTE.GROUPE_TRAVAIL {
    background-color: #f1a1ad !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.MECSS {
    background-color: #227200 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.DELEGATION  {
    background-color: #00773E !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.DELEGATION.AUDRAP {
    background-color: #00A254 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.DELEGATION.GROUPE_TRAVAIL {
    background-color: #04BA62 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.BUREAU {
    background-color: #D8A10D !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.QUESTURE {
    background-color: #f2bf36 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.CONF_PRES {
    background-color: #88B1A5 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.ETUDES {
    background-color: #b9d2cb !important; color: #5B5B70 !important; border: 1px solid lightgrey;
}

a.GIA {
    background-color: #7E80D6 !important; color: #FFF !important; border: 1px solid lightgrey;
}

a.DEPLACEMENT {
    background-color: #9C9EE4 !important; color: #FFF !important; font-style: italic !important; border: 1px solid lightgrey;
}

a.EXCUSE {
    background-color: #C0C0C0 !important; color: #FFF !important; font-style: italic !important; border: 1px solid lightgrey;
}

a.EXCUSES {
    background-color: #C0C0C0 !important; color: #FFF !important; font-style: italic !important; border: 1px solid lightgrey;
}

a.REUNION_INTERNATIONALE {
    background-color: #BBBCF0 !important; color: #5B5B70 !important; font-style: italic !important; border: 1px solid lightgrey;
}

a.AUTRE {
    background-color: #958C94 !important; color: #FFF !important; font-style: italic !important; border: 1px solid lightgrey;
}

a.AUTRE_INVID {
    background-color: #958C94 !important; color: #FFF !important; font-style: italic !important; border: 1px solid lightgrey;
}


a.REUNION_COMMUNE{ background-color: #a13646 !important; color: #FFF !important; border: 1px solid lightgrey;  }

a.SENATEUR {
    background-color: darkorange !important;
    color: #FFF !important;
    font-style: italic !important;
}

a.SUSPENSION {
    background-color: grey;
    color: #FFF;
    font-style: italic !important;
}

a.MANDAT {
    text-align: center;
    color: black;
    font-weight: bold;font-size: large;
    background:linear-gradient(90deg, #0055A4 33.3%, #FFF 33.3%, #FFF 66.6%, #EF4135 66.6%, #EF4135);
}

a {
    text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// SenateurCentral.vue?1c173f34